module.exports = __webpack_public_path__ + "img/pc_footer_img.04a6729.webp";